import * as React from 'react';
import { Component, Fragment } from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Icon from './Icon';
import Translate from './Translate';

const StarRatingWrapper = styled<any, any>('div')`
    ${propStyles};
`;

StarRatingWrapper.defaultProps = {
    display: 'flex',
};

const StarIcon = styled<any, any>(Icon)`
    ${propStyles};
`;

StarIcon.defaultProps = {
    height: '1em',
    width: '1em',
};

const StarOutlineIcon = styled<any, any>(Icon)`
    ${propStyles};
`;

StarOutlineIcon.defaultProps = {
    height: '1em',
    width: '1em',
};

interface StarRatingProps {
    theme?: { [property: string]: string | number };
    showEmptyStars?: boolean;
    maxRating?: number;
    rating: number | string;
    display?: string;
    noDataPlaceholder?: string;
}

@observer
class StarRating extends Component<StarRatingProps> {
    constructor(props) {
        super(props);
    }

    @computed
    get starRatingContent() {
        const {
            rating = 0,
            noDataPlaceholder,
            maxRating = 5,
            showEmptyStars,
            theme,
        } = this.props;
        const ratingNumber = parseInt(rating as any, 10);
        // If we are not able to get a number, display the rating value
        // In this case it is likely to be a no data placeholder
        // use placeholder if rating equals 0
        if (isNaN(ratingNumber) || ratingNumber === 0) {
            // use placeholder if no rating or rating is empty
            if (noDataPlaceholder) {
                return <Translate>{noDataPlaceholder}</Translate>;
            }
            return <Translate>{rating}</Translate>;
        }

        const stars = Array.from(Array(ratingNumber).keys()).slice(
            0,
            maxRating
        );
        const emptyStars = showEmptyStars
            ? Array.from(Array(maxRating).keys())
            : [];
        return (
            <Fragment>
                {stars.map((star, idx) => {
                    const altTextRating =
                        idx === 0 ? `${stars.length} of 5` : '';
                    const disableAltText = idx !== 0;
                    return (
                        <StarIcon
                            key={idx}
                            fileName="MorningstarIcon"
                            {...theme.StarIcon}
                            accessibilityContext={altTextRating}
                            disableAltText={disableAltText}
                        />
                    );
                })}
                {emptyStars.slice(stars.length).map((emptyStar, idx) => {
                    return (
                        <StarOutlineIcon
                            key={idx}
                            fileName="MorningstarOutlineIcon"
                            {...theme.StarOutlineIcon}
                        />
                    );
                })}
            </Fragment>
        );
    }

    render() {
        const { starRatingContent, props } = this;
        const { theme } = props;

        return (
            <StarRatingWrapper {...props} {...theme.StarRatingWrapper}>
                {starRatingContent}
            </StarRatingWrapper>
        );
    }
}

export default withTheme(StarRating);



// WEBPACK FOOTER //
// ./src/Components/StarRating.tsx